import { render } from "./lInActive.vue?vue&type=template&id=7b921423"
import script from "./lInActive.vue?vue&type=script&lang=js"
export * from "./lInActive.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__